import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { filtersStep, listTableStep, newSubmittalStep } from './steps';

export const SUBMITTALS_LIST_TOUR_ID = 'submittals.list';

registerTour({
  id: SUBMITTALS_LIST_TOUR_ID,
  name: 'Submittals',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.SUBMITTALS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Submittals',
      body:
        'Track shop drawings, product data, samples, and any other ' +
        'submittal that needs review and approval — through every revision.',
    },
    newSubmittalStep,
    filtersStep,
    listTableStep,
  ],
});
